module.exports = __webpack_public_path__ + "img/indicator3a_gray_v2.4d1981f7.svg";